import { defineMessages } from 'react-intl-next';

export const messages: {
	addPeopleButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	addPeopleButtonLabel: {
		id: 'ptc-directory.add-people.button',
		defaultMessage: 'Add people',
		description: 'The text on the button that opens the Add People modal',
	},
});
